export const BRAND = {
  name: 'NORBERTH Presenta',
  instagramHandle: '@norberthperez',
  logoUrl: 'https://cdn.magicpatterns.com/uploads/dHgh75i9yyXH9fRg8HmMG6/logo_norberth_.png',
  bannerUrl: 'https://cdn.magicpatterns.com/uploads/v2N5unezL7B3J4BwkPqe8K/banner_norberth.png',
  footerUrl: 'https://cdn.magicpatterns.com/uploads/aAyUBGfU1vXPdvQ2WDm6DZ/footer_norberth.png',
  whatsappNumber: '+1 305 988 3803',
  whatsappUrl: 'https://wa.me/13059883803',
  instagramUrl: 'https://www.instagram.com/norberthperez',
  facebookUrl: 'https://www.facebook.com/share/1EZjPkJNWC/?mibextid=wwXIfr',
  youtubeUrl: 'https://www.youtube.com/@norberthperez',
}

export type NavItem = {
  label: string
  href: string
}

export const navItems: NavItem[] = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Producciones', href: '#producciones' },
  { label: 'Biografía', href: '#biografia' },
  { label: 'Sobre Norberth', href: '#sobre' },
  { label: 'Reunión', href: '#reunion' },
  { label: 'Preguntas', href: '#faq' },
]

export type Service = {
  id: string
  icon: 'mic' | 'clapperboard' | 'presentation' | 'radio' | 'handshake' | 'megaphone'
  title: string
  description: string
}

export const services: Service[] = [
  {
    id: 'conduccion',
    icon: 'mic',
    title: 'Conducción de eventos',
    description:
      'Presentación en vivo para lanzamientos, galas y activaciones de marca con ritmo, guion y presencia escénica.',
  },
  {
    id: 'produccion',
    icon: 'clapperboard',
    title: 'Producción audiovisual',
    description:
      'Concepto, grabación y edición de piezas de marca con estándar de televisión.',
  },
  {
    id: 'maestro',
    icon: 'presentation',
    title: 'Maestro de ceremonias',
    description:
      'Conducción corporativa que sostiene la agenda, cuida los tiempos y mantiene la energía de la sala.',
  },
  {
    id: 'entrevistas',
    icon: 'radio',
    title: 'Entrevistas y podcast',
    description:
      'Conversaciones que revelan el lado humano de fundadores, equipos y proyectos.',
  },
  {
    id: 'vocero',
    icon: 'handshake',
    title: 'Vocería de marca',
    description:
      'Representación de marca en medios, campañas y contenidos con una voz reconocible.',
  },
  {
    id: 'estrategia',
    icon: 'megaphone',
    title: 'Estrategia de contenido',
    description:
      'Narrativa, formatos y calendario para que la marca comunique con constancia.',
  },
]

export type Production = {
  id: string
  category: string
  title: string
  image: string
}

export const productions: Production[] = [
  {
    id: 'entrevistas',
    category: 'Entrevistas',
    title: 'Voces que conectan',
    image:
      'https://cdn.magicpatterns.com/uploads/qECb3UNnj2ZkGuxRbHNrue/NORBERTH_Entrevistas_Voces_Que_Conectan.png',
  },
  {
    id: 'actualidad',
    category: 'Actualidad',
    title: 'Volvemos a la Luna',
    image:
      'https://cdn.magicpatterns.com/uploads/3goKEAUu4arb7qKMCuR7xP/ChatGPT_Image_2_ago_2026,_03_43_57_p.m..png',
  },
  {
    id: 'comunidad',
    category: 'Comunidad',
    title: 'Creatividad que une',
    image:
      'https://cdn.magicpatterns.com/uploads/gkhtHeFJGLTz9xFTvTj2py/ChatGPT_Image_2_ago_2026,_03_44_16_p.m..png',
  },
  {
    id: 'sabores',
    category: 'Sabores',
    title: 'Sabores que conectan',
    image:
      'https://cdn.magicpatterns.com/uploads/96hDkeyWBAB5wRb9UVJ5oM/ChatGPT_Image_2_ago_2026,_03_44_30_p.m..png',
  },
  {
    id: 'gastronomia',
    category: 'Gastronomía',
    title: 'Sabores que conectan',
    image:
      'https://cdn.magicpatterns.com/uploads/ahGB1jUCEfTYtGU57ZwNj2/ChatGPT_Image_2_ago_2026,_07_32_49_p.m..png',
  },
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Cómo empieza un proyecto?',
    answer:
      'Con una reunión inicial donde revisamos el objetivo, el formato y la fecha. A partir de ahí se define la propuesta.',
  },
  {
    question: '¿Trabajas con eventos fuera de la ciudad?',
    answer:
      'Sí. La agenda se coordina con anticipación y los detalles de traslado se acuerdan en la propuesta.',
  },
  {
    question: '¿Qué necesito tener listo antes de la reunión?',
    answer:
      'El tipo de evento o pieza, la fecha estimada y el mensaje principal que la marca quiere transmitir.',
  },
  {
    question: '¿Se puede contratar solo la producción audiovisual?',
    answer:
      'Sí. Cada servicio puede contratarse por separado o combinarse en un mismo proyecto.',
  },
  {
    question: '¿Cuál es el canal más rápido de contacto?',
    answer:
      'WhatsApp para consultas puntuales y la solicitud de reunión para revisar un proyecto a fondo.',
  },
]

export const timeSlots = ['09:00', '10:30', '12:00', '15:00', '16:30', '18:00']

export const legalContent = {
  privacy: {
    title: 'Política de privacidad',
    sections: [
      {
        heading: 'Datos que recopilamos',
        body: 'Recopilamos únicamente los datos que envías de forma voluntaria en el formulario de solicitud de reunión: nombre, correo electrónico, empresa, servicio de interés y fecha preferida.',
      },
      {
        heading: 'Uso de la información',
        body: 'La información se utiliza exclusivamente para coordinar la reunión solicitada y responder tu consulta. No se emplea para fines distintos a los indicados.',
      },
      {
        heading: 'Conservación y terceros',
        body: 'Los datos se conservan el tiempo necesario para atender la solicitud. No se venden ni se ceden a terceros con fines comerciales.',
      },
      {
        heading: 'Tus derechos',
        body: 'Puedes solicitar el acceso, la corrección o la eliminación de tus datos escribiendo por los canales de contacto disponibles en esta página.',
      },
    ],
  },
  terms: {
    title: 'Términos y condiciones',
    sections: [
      {
        heading: 'Alcance del sitio',
        body: 'Este sitio presenta los servicios profesionales de NORBERTH Presenta. El envío de una solicitud no constituye una contratación ni una reserva confirmada.',
      },
      {
        heading: 'Confirmación de reuniones',
        body: 'Toda solicitud de reunión queda sujeta a confirmación según disponibilidad de agenda. La confirmación se realiza por los canales de contacto acordados.',
      },
      {
        heading: 'Propiedad intelectual',
        body: 'El logotipo, las fotografías, los textos y las piezas audiovisuales presentes en este sitio pertenecen a NORBERTH Presenta y no pueden reproducirse sin autorización.',
      },
      {
        heading: 'Enlaces externos',
        body: 'Los enlaces a redes sociales y plataformas de terceros se abren en una pestaña nueva y se rigen por sus propias condiciones de uso.',
      },
    ],
  },
}
